module.exports = __webpack_public_path__ + "static/media/profile.c1e38034.jpg";